import React from 'react'
import { Route } from '../../../../../node_modules/react-router-dom/cjs/react-router-dom.min'
import { DeviceLoginDenialList } from './page/device-login-denial-list'
import { DeviceLoginDenialSummary } from './page/device-login-denial-summary'

export const LayoutDeviceLoginDenial = () => {
  return (
    <React.Fragment>
      <Route path="/admin/device-login-denial/list" component={DeviceLoginDenialList} />
      <Route path="/admin/device-login-denial/summary" component={DeviceLoginDenialSummary} />
    </React.Fragment>
  )
}
